import React from 'react';
import { useSelector } from 'react-redux';
import Chart, { ChartProps, filterOutNulls } from '../../../components/chart/Chart';
import { ApplicationState } from '../../../store';
import { CeclApiState, ChartData, Chart as ChartType } from '../../../store/ceclapi/types';

const initialChartProps: ChartProps = {
    options: {
        title: {
            text: 'Qrtly Deposit Growth',
            fontSize: 20,
            fontFamily: 'Montserrat',
            fontWeight: 'bolder',
            margin: 50,
        },
        dataSetNamesForYAxis1: ['CU CU', 'Asset Size Asset Size'],
        axisY: {
            valueFormatString: "#%"            
        },
    },
    data: [],
    id: 'qrtlydepositgrowth',
};

const accounts: string[] = ['DepositGrowth'];

const QrtlyDepositGrowth: React.FC<ChartProps> = (props) => {
    const cecl = useSelector<ApplicationState, CeclApiState>((state) => state.cecl);
    const [chartProps, setChartProps] = React.useState<ChartProps>({ ...initialChartProps, ...props });

    const prepChartData = (chart: ChartType): ChartData[] => {

        const myChartData: ChartData[] = JSON.parse(JSON.stringify(chart.data));

        if (myChartData) {
            const mappedData = myChartData.filter((d) => accounts.includes(d.name)).map((d) => {
                d.name = chart.graphName?.includes("CU") ? cecl.user?.creditUnionName : cecl.dashboardData?.info?.ceclPeerGroupDescription;
                d.type = 'column';
                d.dataPoints = d.dataPoints?.sort((a, b) => {
                    const dateA: Date = new Date(a.label);
                    const dateB: Date = new Date(b.label);

                    return dateA.getTime() - dateB.getTime();
                }).map((dp) => {
                    dp.x = undefined;
                    dp.y = +dp.y;

                    return dp;
                });

                return d;
            });

            return mappedData;
        }

        return [];
    };

    React.useEffect(() => {
        const charts = cecl.dashboardData?.charts?.filter(
            (d) => chartProps.options.dataSetNamesForYAxis1.includes(d.graphName)
        );

        let shouldSetToInitial: boolean = true;
        let jointData: ChartData[] = [];

        if (charts && charts.length > 0) {

            shouldSetToInitial = false;

            for(let i = 0; i < charts.length; i++){
                jointData = [...jointData, ...prepChartData(charts[i])];
            }

            jointData = filterOutNulls(jointData); 
        }

        if (shouldSetToInitial) {
            setChartProps(initialChartProps);
        } else {
            setChartProps((prevState) => ({
                ...prevState,
                data: jointData,
            }));
        }
    }, [cecl.dashboardData]);

    return (
        <>
            <Chart loading={cecl.dashboardData?.loading} {...chartProps} />
        </>
    );
};

export default QrtlyDepositGrowth;
